<template>
  <div>
    <v-container class="ml-10 mr-10">
      <p class="display-1 mt-7">인증 코드 생성 (엑셀등록)</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        소프트웨어 인증을 위한 시리얼 코드를 쇼핑몰 상품과 매칭하여 생성합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        사용이 가능한 시리얼 코드를 엑셀 업로드하여 사용이 가능합니다.
      </p>

      <ExcelMatchCreateAuthCode></ExcelMatchCreateAuthCode>
    </v-container>
  </div>
</template>
<style scoped>
.disabledTab {
  font-size: 1.25rem !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: default;
  color: #bababa;
}
</style>
<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import ExcelMatchCreateAuthCode from "@/components/authservice/authcode/ExcelMatchCreateAuthCode.vue";
import { AUTH_SERVICE } from "@/datas/authservice";
import M from "@/libs/mapping.js";

export default {
  data: () => ({
    AUTH_SERVICE,
    duration: {
      cert_duration_type: AUTH_SERVICE.ACTIVATED,
      cert_duration: "1d",
      days: 1,
      days_type: "d"
    }
  }),
  components: {
    ExcelMatchCreateAuthCode
  },
  mixins: [CommonMixin],
  created: async function() {
    /**
     * 설정 데이터 가져오기
     */
    await this.getDuration();
  },
  methods: {
    /**
     * 데이터 가져오기
     */
    getDuration: async function() {
      let data = await M.api(M.entry("/get/duration"));
      if (data) {
        this.duration.cert_duration_type = data.duration_type;
        this.duration.cert_duration = data.duration;
        this.duration.days = data.duration.replace(/[a-z]/gi, "");
        this.duration.days_type = data.duration.replace(/[0-9]/g, "");
      }
    },
    checkVersionAlret: function() {
      let msg =
        "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      this.alertShow(msg);
    }
  }
};
</script>
